import { CATEGORY_TYPE_OPTIONS } from '@/features/product-configurator/constants';
import { Form, Select, Input } from 'antd';

export const CategoryForm = () => {

  return (
    <div className="pt-4">
      <Form.Item
        label="Category Type"
        name="dogma_categorytype"
        rules={[{ required: true, message: 'Please select category type' }]}
      >
        <Select placeholder="Select category type" options={CATEGORY_TYPE_OPTIONS} />
      </Form.Item>

      <Form.Item
        label="Category Name"
        name="dogma_name"
        rules={[{ required: true, message: 'Please enter category name' }]}
      >
        <Input placeholder="Enter category name" />
      </Form.Item>

      <Form.Item
        label="Description"
        name="dogma_description"
      >
        <Input.TextArea placeholder="Enter description" rows={2} />
      </Form.Item>
    </div>
  );
};
